/* VersionControl.js */

"use strict";
const Registrations = require("../../RegistrationNamespaces");

module.exports = {
    name: "version_control",
    label: "Version Control",
    disabled: false,
    app: "GameConsole",
    order: 6, // Deprecated -- Newer solution uses order from index.js
    section: "GameCenter",
    license: ["GLUWARE"],
    accessPerm: ["versionControlAccess"],
    pageTitle: "Version Control",
    helpLink: "Device%20Manager/Version-Control-quick-reference.htm",
    navIcon: "versioncontrol.solution",
    lmrbNamespaces: [Registrations.VERSION_CONTROL_EXPLORER_LMRB],
    editorNamespaces: [],
    versionControlExplorer: {
        viewNamespaces: [],
        actionNamespaces: [Registrations.VERSION_CONTROL_ACTION_COMMIT_PUSH],
    },
    versionControlEditor: {
        viewNamespaces: [Registrations.VERSION_CONTROL_VIEW_DETAILS],
        actionNamespaces: [],
    },
};
